/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface CreateContactScriptManifestRequest
 */
export interface CreateContactScriptManifestRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateContactScriptManifestRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateContactScriptManifestRequest
     */
    source?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateContactScriptManifestRequest
     */
    trigger?: string;
}

/**
 * Check if a given object implements the CreateContactScriptManifestRequest interface.
 */
export function instanceOfCreateContactScriptManifestRequest(value: object): boolean {
    return true;
}

export function CreateContactScriptManifestRequestFromJSON(json: any): CreateContactScriptManifestRequest {
    return CreateContactScriptManifestRequestFromJSONTyped(json, false);
}

export function CreateContactScriptManifestRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateContactScriptManifestRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'source': json['source'] == null ? undefined : json['source'],
        'trigger': json['trigger'] == null ? undefined : json['trigger'],
    };
}

export function CreateContactScriptManifestRequestToJSON(value?: CreateContactScriptManifestRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'source': value['source'],
        'trigger': value['trigger'],
    };
}

